/**
 * Pure date-range helpers for the admin Sales screen's quick picks (Today /
 * Yesterday / Last 7 days). Kept free of any timezone library: Kuala Lumpur
 * is a fixed UTC+8 offset with no DST (see api/src/lib/time.ts, which this
 * mirrors for the same reason - the web package can't import from api/).
 */

const KL_OFFSET_MS = 8 * 60 * 60 * 1000;

/** Today's KL calendar date for `now`, as "YYYY-MM-DD". */
export function klTodayFrom(now: Date): string {
  const shifted = new Date(now.getTime() + KL_OFFSET_MS);
  return shifted.toISOString().slice(0, 10);
}

/** Adds (or subtracts) whole calendar days to a "YYYY-MM-DD" date string. */
export function addDaysKl(date: string, days: number): string {
  const [y, m, d] = date.split('-').map(Number);
  const dt = new Date(Date.UTC(y!, (m ?? 1) - 1, d));
  dt.setUTCDate(dt.getUTCDate() + days);
  return dt.toISOString().slice(0, 10);
}

export type DateRangePreset = 'today' | 'yesterday' | 'last7';

export interface DateRange {
  from: string;
  to: string;
}

/** Inclusive KL-calendar `{ from, to }` for one of the Sales screen's quick picks. */
export function computeDateRangePreset(preset: DateRangePreset, now: Date = new Date()): DateRange {
  const today = klTodayFrom(now);
  switch (preset) {
    case 'today':
      return { from: today, to: today };
    case 'yesterday': {
      const yesterday = addDaysKl(today, -1);
      return { from: yesterday, to: yesterday };
    }
    case 'last7':
      return { from: addDaysKl(today, -6), to: today };
  }
}
